import { render, staticRenderFns } from "./HomePageInfo.vue?vue&type=template&id=4a021407&scoped=true&"
import script from "./HomePageInfo.vue?vue&type=script&lang=js&"
export * from "./HomePageInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomePageInfo.vue?vue&type=style&index=0&id=4a021407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a021407",
  null
  
)

export default component.exports